import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    addBeneficiary: 'Add a Beneficial Owner',
  },
  fr: {
    addBeneficiary: 'Ajouter un bénéficiaire effectif',
  },
} as const);
